import { useEffect, useState, useCallback, useRef } from "react";
import useTitle from "../hooks/TitleManager";
import PageContainer from "../components/pageContainer/PageContainer";
import ApiDatabase from "../server";
import NavBarActivity from "../components/navbars/NavBarActivity";
import TableActivities from "../components/tables/TableActivities";
import EmptyState from "../components/EmptyState/EmptyState";
import {
  dateLong,
  dateShort,
  dateShortHours,
  dateShortHoursWithoutYear,
} from "../utils/Date";
import Button from "../components/button";
import { EyeIcon } from "../assets/icons";
import useModal from "../components/modal/useModal";
import UseContext from "../hooks/useContext";
import Pagination from "../components/pagination/Pagination";

const Activity = () => {
  useTitle({ title: "Activité" });
  const { toggle } = useModal();
  const { setModalData, companySelected } = UseContext();
  const [activitiesToDisplay, setActivitiesToDisplay] = useState([]);
  const [isWaitingActivity, setIsWaitingActivity] = useState(true);
  const activityRequestIdRef = useRef(0);

  const [employeeSelectedActivity, setEmployeeSelectedActivity] = useState([]);
  const [dateSelect, setDateSelect] = useState(null);
  const [search, setSearch] = useState("");
  const [actionSelected, setActionSelected] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const countPerPage = 25;
  const [countTotal, setCountTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    setEmployeeSelectedActivity([]);
  }, [companySelected?.idCompany]);

  useEffect(() => {
    setCurrentPage(1);
  }, [search, employeeSelectedActivity, dateSelect, actionSelected]);

  const openModalActivity = useCallback(
    (activity) => {
      toggle("log_time_sheet");
      setModalData({
        employee: activity.employee,
        mission: activity.description?.title?.text,
        date: dateShortHoursWithoutYear(activity.date, "/"),
        details: activity.details,
      });
    },
    [toggle, setModalData],
  );

  const transformActivities = useCallback((activities) => {
    return activities
      .map((activity) => {
        if (activity.type === "exportMission") {
          return {
            type: activity.type,
            typeStatus: activity.typeStatus,
            idEmployee: activity.idEmployee,
            idCompany: activity.idCompany,
            date: (
              <div className={"text-sm text-gray-500"}>
                {dateShortHours(activity.date, "/")}
              </div>
            ),
            dateOriginal: activity.date,
            employee: <div className={"text-sm"}>{activity.employee}</div>,
            title: <div className={"text-sm"}>{activity.title?.text}</div>,
            description: (
              <div className={"text-sm"}>
                <div>{activity.description?.title?.text}</div>
                <div className={"text-gray-500 flex gap-1"}>
                  {dateShort(activity.description?.description?.date?.start)} {">"}{" "}
                  {dateShort(activity.description?.description?.date?.end)}
                </div>
              </div>
            ),
            search: `${activity.description?.title?.text} ${activity.description?.description?.date?.start} ${activity.description?.description?.date?.end}`,
          };
        } else if (activity.type === "tempWorkerPhone") {
          return {
            type: activity.type,
            typeStatus: activity.typeStatus,
            idEmployee: activity.idEmployee,
            idCompany: activity.idCompany,
            date: (
              <div className={"text-sm text-gray-500"}>
                {dateShortHours(activity.date, "/")}
              </div>
            ),
            dateOriginal: activity.date,
            employee: <div className={"text-sm"}>{activity.employee}</div>,
            title: <div className={"text-sm"}>{activity.title.text}</div>,
            description: (
              <div className={"text-sm"}>
                <div>{activity.description?.title?.text}</div>
                <div className={"text-gray-500"}>
                  {activity.description?.description?.text}
                </div>
              </div>
            ),
            search: `${activity.description?.title?.text} ${activity.description?.description?.text}`,
          };
        } else if (activity.type === "timeSheet") {
          return {
            type: activity.type,
            typeStatus: activity.typeStatus,
            idEmployee: activity.idEmployee,
            idCompany: activity.idCompany,
            date: (
              <div className={"text-sm text-gray-500"}>
                {dateShortHours(activity.date, "/")}
              </div>
            ),
            dateOriginal: activity.date,
            employee: <div className={"text-sm"}>{activity.employee}</div>,
            title: (
              <div className={"flex gap-1 justify-between items-center"}>
                <div className={"text-sm flex gap-1"}>
                  <div>{activity.title.text}</div>
                  <div className={"capitalize"}>
                    ({dateLong(new Date(activity.title.date))})
                  </div>
                </div>
                <Button
                  size={"ICON"}
                  color={"ICON"}
                  onClick={() => openModalActivity(activity)}
                >
                  <EyeIcon wh={20} color={"#374151"} />
                </Button>
              </div>
            ),
            description: (
              <div className={"text-sm"}>
                <div>{activity.description?.title?.text}</div>
              </div>
            ),
            search: `${activity.description?.title?.text}`,
          };
        } else if (activity.type === "pdnsCompany") {
          return {
            type: activity.type,
            typeStatus: activity.typeStatus,
            idEmployee: activity.idEmployee,
            idCompany: activity.idCompany,
            date: (
              <div className={"text-sm text-gray-500"}>
                {dateShortHours(activity.date, "/")}
              </div>
            ),
            dateOriginal: activity.date,
            employee: <div className={"text-sm"}>{activity.employee}</div>,
            title: <div className={"text-sm"}>{activity.title?.text}</div>,
            description: (
              <div className={"text-sm"}>
                <div>{activity.description?.title?.text}</div>
              </div>
            ),
            search: `${activity.title?.text} ${activity.description?.title?.text}`,
          };
        } else if (activity.type === "sundayHoursCompany") {
          return {
            type: activity.type,
            typeStatus: activity.typeStatus,
            idEmployee: activity.idEmployee,
            idCompany: activity.idCompany,
            date: (
              <div className={"text-sm text-gray-500"}>
                {dateShortHours(activity.date, "/")}
              </div>
            ),
            dateOriginal: activity.date,
            employee: <div className={"text-sm"}>{activity.employee}</div>,
            title: <div className={"text-sm"}>{activity.title?.text}</div>,
            description: (
              <div className={"text-sm"}>
                <div>{activity.description?.title?.text}</div>
              </div>
            ),
            search: `${activity.title?.text} ${activity.description?.title?.text}`,
          };
        }
        return null;
      })
      .filter((activity) => activity !== null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!companySelected?.idCompany) {
      activityRequestIdRef.current += 1;
      setActivitiesToDisplay([]);
      setCountTotal(0);
      setTotalPages(0);
      setIsWaitingActivity(true);
      return;
    }

    const requestId = activityRequestIdRef.current + 1;
    activityRequestIdRef.current = requestId;
    setIsWaitingActivity(true);
    ApiDatabase.getActivities(
      {
        companyId: companySelected.idCompany,
        page: currentPage,
        limit: countPerPage,
        search,
        employeeIds: employeeSelectedActivity
          .map((employee) => employee.idEmployee)
          .join(","),
        date: dateSelect?.toISOString(),
        actionTypes: actionSelected.map((action) => action.type).join(","),
      },
      (data) => {
        if (requestId !== activityRequestIdRef.current) return;

        setActivitiesToDisplay(transformActivities(data.activities || []));
        setCountTotal(data.total || 0);
        setTotalPages(data.totalPages || 0);
        setIsWaitingActivity(false);
      },
      (err) => {
        if (requestId !== activityRequestIdRef.current) return;

        setActivitiesToDisplay([]);
        setCountTotal(0);
        setTotalPages(0);
        setIsWaitingActivity(false);
        console.log(err);
      },
    );
  }, [
    transformActivities,
    companySelected?.idCompany,
    actionSelected,
    employeeSelectedActivity,
    dateSelect,
    search,
    currentPage,
  ]);

  const activityTableColumnHeader = (
    <div
      className={`grid grid-cols-5 gap-8 px-4 py-3 text-sm font-medium text-gray-900`}
    >
      <div className={"flex flex-col justify-center"}>Date d&apos;activité</div>
      <div className={"flex flex-col justify-center"}>Utilisateur</div>
      <div className={"flex flex-col justify-center col-span-2"}>Action</div>
      <div className={"flex flex-col justify-center"}>Objet</div>
    </div>
  );

  return (
    <PageContainer type={"activity"} contentLayout="activity">
      <div className="flex min-h-0 flex-1 flex-col">
        <div className="shrink-0 px-[20px] pb-4 pt-3">
          <NavBarActivity
            employeeSelectedActivity={employeeSelectedActivity}
            setEmployeeSelectedActivity={setEmployeeSelectedActivity}
            dateSelect={dateSelect}
            setDateSelect={setDateSelect}
            search={search}
            setSearch={setSearch}
            actionSelected={actionSelected}
            setActionSelected={setActionSelected}
          />
        </div>
        <div className="h-px shrink-0 bg-gray-100" aria-hidden="true" />
        <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-hidden px-[20px] pt-2 pb-6">
          <div className="min-h-0 flex-1 overflow-auto">
            {isWaitingActivity ? (
              <div className={"flex flex-col gap-3 min-w-[830px] animate-pulse"}>
                {[1, 2, 3, 4, 5].map((index) => (
                  <TableActivities key={index} isWaiting={true} />
                ))}
              </div>
            ) : (
              <>
                {activitiesToDisplay.length > 0 ? (
                  <div className={"flex flex-col gap-3 min-w-[830px]"}>
                    <div
                      className={
                        "sticky top-0 z-10 border-b border-gray-100 bg-white"
                      }
                    >
                      {activityTableColumnHeader}
                    </div>
                    {activitiesToDisplay.map((activity, index) => (
                      <TableActivities key={index} activity={activity} />
                    ))}
                  </div>
                ) : (
                  <EmptyState type={"activity"} />
                )}
              </>
            )}
          </div>
          <Pagination
            currentPage={currentPage}
            countPerPage={countPerPage}
            countTotal={countTotal}
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </PageContainer>
  );
};

export default Activity;
